import React from 'react';

interface SkeletonDashboardCardsDividendsRowProps {
    children: React.ReactNode;
    strong?: boolean;
    large?: boolean;
}

export const SkeletonDashboardCardsDividendsRow: React.FC<SkeletonDashboardCardsDividendsRowProps> = ({
    children,
    strong = false,
    large = false,
}) => (
    <div
        className={
            large
                ? 'text-large leading-large font-black text-text'
                : `flex gap-[1.4rem] text-medium leading-medium${strong ? ' font-black' : ''}`
        }
    >
        {children}
    </div>
);
